module.exports = __webpack_public_path__ + "img/21.f61f0c56.jpg";